export const FieldNames = {
  School: "school",
  ShowClosed: "show_closed",
}
